import React, { useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Contact from "./components/Contacts";
import Footer from "./components/Footer";
import DevToolsModal from "./components/DevToolsModal";
import Projects from "./components/Projects";
import Labs from "./components/Labs";
import Skills from "./components/Skills";
import LoadingModal from "./components/LoadingModal";    

const HomePage: React.FC = () => {
  const [showDevToolsModal, setShowDevToolsModal] = useState(false);

  useEffect(() => {
    const triggerModal = () => setShowDevToolsModal(true);

    const handleContextMenu = (e: MouseEvent) => {
      e.preventDefault();
      e.stopPropagation();
      triggerModal();
    };
    document.addEventListener("contextmenu", handleContextMenu, true);

    const blockedKeys = new Set(["F12"]);
    const handleKeyDown = (e: KeyboardEvent) => {
      if (blockedKeys.has(e.key)) {
        e.preventDefault();
        e.stopPropagation();
        triggerModal();
        return;
      }
      if (e.ctrlKey && e.shiftKey) {
        const key = e.key.toUpperCase();
        if (["I", "J", "C", "K"].includes(key)) {
          e.preventDefault();
          e.stopPropagation();
          triggerModal();
          return;
        }
      }
      if (e.ctrlKey && e.key === "u") {
        e.preventDefault();
        e.stopPropagation();
        triggerModal();
        return;
      }
      if (e.metaKey && e.altKey && e.key === "i") {
        e.preventDefault();
        e.stopPropagation();
        triggerModal();
        return;
      }
    };
    document.addEventListener("keydown", handleKeyDown, true);

    let devtoolsOpen = false;
    const threshold = 200;

    const detectDevTools = () => {
      const widthOpen = window.outerWidth - window.innerWidth > threshold;
      const heightOpen = window.outerHeight - window.innerHeight > threshold;

      if (widthOpen || heightOpen) {
        if (!devtoolsOpen) {
          devtoolsOpen = true;
          triggerModal();
        }
      } else {
        devtoolsOpen = false;
      }
    };

    const intervalId = setInterval(detectDevTools, 800);

    return () => {
      document.removeEventListener("contextmenu", handleContextMenu, true);
      document.removeEventListener("keydown", handleKeyDown, true);
      clearInterval(intervalId);
    };
  }, []);

  return (
    <div className="bg-primary min-h-screen relative">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Skills />
        <Projects />
        <Contact />
      </main>
      <Footer />
      <DevToolsModal
        isOpen={showDevToolsModal}
        onClose={() => setShowDevToolsModal(false)}
      />
    </div>
  );
};

const App: React.FC = () => {
  const [isLoading, setIsLoading] = useState(true);

  const handleLoadComplete = () => {
    setIsLoading(false);
  };

  return (
    <>
      <LoadingModal onLoadComplete={handleLoadComplete} />
      {!isLoading && (
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/labs" element={<div className="bg-primary min-h-screen relative"><Navbar /><Labs /><Footer /></div>} />
        </Routes>
      )}
    </>
  );
};

export default App;
